"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var baseImage_1 = require("./baseImage");
var background = {
    BACKGROUND: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n\n    fragment Background on Background {\n      code\n      shortname\n      attributes {\n        oemcode\n      }\n      image {\n        ...BaseImage\n      }\n    }\n  "], ["\n    ", "\n\n    fragment Background on Background {\n      code\n      shortname\n      attributes {\n        oemcode\n      }\n      image {\n        ...BaseImage\n      }\n    }\n  "])), baseImage_1.default.BASE_IMAGE),
};
exports.default = background;
var templateObject_1;
